import React from 'react';
import PropTypes from 'prop-types';
import styles from './TermAndConditionsContent.module.scss';

export const TermAndConditionsContent = props => {

  return (
    <div className={styles.container}>
      <h4>Bienvenido a IdAuto Inscripción</h4>
      <p>
        Términos y Condiciones de uso Sistema ID AUTO Inscripción y habilitación para circulación para vehículos nuevos
      </p>

      <h4>PRIMERO: GENERALIDADES</h4>
      <p>
        DOX es una compañía de servicios de Tecnologías de la Información especializada en tecnología Cloud y Gestión
        Documental.
      </p>

      <p>
        Estos Términos y Condiciones tienen por objeto establecer cláusulas y condiciones generales bajo las cuales DOX
        presta el servicio Id Auto Inscripción para Vehículos Nuevos en su portal de Internet, <a
        href="inscripciones.idauto.cl">inscripciones.idauto.cl</a>
      </p>

      <p>
        La aceptación de estos términos y condiciones es condición esencial para la prestación del servicio y se
        entenderá incorporados en la contratación del servicio con DOX por medio de este sitio web.
      </p>

      <h4>SEGUNDO: DEFINICIONES</h4>
      <p>
        Los términos definidos a continuación tendrán el significado que se indica a continuación, aquellos se
        entenderán como conceptos específicos y de uso corriente para la interpretación y aplicación de estos Términos y
        Condiciones, siempre y cuando vayan en mayúscula o lleven en mayúscula su primera letra, ya sea que se utilicen
        en singular o plural, a menos que, en el contexto en que dichos términos se usan se establezca expresamente otra
        cosa.
      </p>

      <ul>
        <li>Adquirente: Es la persona natural o jurídica que adquiere un vehículo nuevo , por tanto, el destinatario
          final de la primera inscripción del vehículo en el Registro Nacional de Vehículos Motorizados con la obtención
          de la placa patente única, junto con el CHI-e (Certificado de Homologación Individual Electrónico), SOAP y
          Permiso de Circulación obtenido en la Municipalidad correspondiente.
        </li>
        <li>
          SOAP: Seguro Obligatorio de Accidentes Personales.
        </li>
        <li>
          RNVM: Registro Nacional de Vehículos Motorizados del Servicio de Registro Civil e Identificación.
        </li>
        <li>
          Certificado de Homologación Individual Electrónico (CHI-e): Es el documento que acredita que la
          comercialización de un determinado vehículo se encuentra amparado en un modelo de vehículo sometido al proceso
          de homologación regulado en los decretos supremos N° 54 de 1997 y 211 de 1991, citados en el Visto. El C.H.I.,
          es la alternativa que existe al certificado de revisión técnica para los vehículos nuevos.
        </li>
        <li>
          DOX: Es la empresa desarrolladora y proveedora del Sistema Id Auto Inscripción objeto de este documento de
          Términos y Condiciones.
        </li>
        <li>
          Automotora: Es el vendedor de automóviles o motos que emite las facturas de venta para sus vehículos nuevos en
          Chile.
        </li>
      </ul>


      <h4>TERCERO: SERVICIO ID AUTO INSCRIPCIÓN y HABILITACIÓN PARA CIRCULACIÓN VEHÍCULOS NUEVOS</h4>
      <p>
        El Sistema ID AUTO INSCRIPCIÓN y HABILITACIÓN PARA CIRCULACIÓN VEHÍCULOS NUEVOS en adelante SISTEMA Id Auto
        Inscripción, desarrollado por DOX es una solución tecnológica, a través de un software que permite tramitar y
        gestionar electrónicamente la primera inscripción vehicular y la obtención de las respectivas placas patentes
        que en definitiva permitirán que los vehículos inscritos puedan circular legalmente en Chile.
      </p>

      <h4>Proceso de Registro de Usuario</h4>
      <h4>Descripción del proceso de Auto Inscripción y Habilitación en Circulación de un vehículo nuevo</h4>
      <p>
        El Proceso de Auto Inscripción es el siguiente:
      </p>

      <ul>
        <li>El vehículo debe ser vendido por la automotora mediante factura electrónica al Adquiriente.</li>
        <li>El adquiriente carga la factura a SISTEMA Id Auto Inscripción e inserta la información solicitada para
          realizar la cotización.
        </li>
        <li>EL adquiriente selecciona el plan que se ajuste a sus necesidades, el medio de pago electrónico y confirma
          haber leído y aceptado estos Términos y Condiciones.
        </li>
        <li>Una vez pagado el servicio inicia el proceso de auto inscripción del cual se le mantendrá informado mediante
          correo electrónico.
        </li>
      </ul>

      <h4>CUARTO: OBLIGACIONES DEL ADQUIRENTE</h4>
      <p>
        El Adquirente debe solicitar trámites para facturas emitidas a su nombre.
      </p>

      <h4>SEXTO: CONDICIONES COMERCIALES Y MEDIOS DE PAGO</h4>
      <h4>Medios de pago</h4>
      <p>
        Salvo que se señale un medio diferente para casos u ofertas específicas, los productos y servicios que se
        informan en este sitio sólo podrán ser pagados por el siguiente medio de pago:
      </p>

      <ul>
        <li>Tarjetas y formas de pago soportadas por WebPay®</li>
      </ul>

      <h4>SÉPTIMO: RESPONSABILIDAD</h4>
      <p>
        La responsabilidad de la información que se entregue a DOX al momento de registrarse es personal, manifestando
        total conformidad con las condiciones del presente documento, por este acto declara conocer que en Chile la
        usurpación de nombre es un delito que se encuentra sancionado penalmente por el ejercicio ilegal de nombre y/o
        por estafa y otros engaños. DOX, en ese sentido realiza controles estrictos con la finalidad de velar porque las
        cuentas sean creadas y utilizadas únicamente por sus titulares.
      </p>
      <p>
        Usted declara y acepta expresamente que el uso del Servicio se realiza bajo su propia responsabilidad y que el
        servicio se suministra "tal cual" y en función de su
        "disponibilidad"
      </p>
      <p>
        DOX no será responsable ante usted por:
      </p>

      <ul>
        <li>
          Ningún daño directo, indirecto, fortuito, especial, derivado ni ejemplar en que usted haya incurrido, sea cual
          sea su causa y bajo ninguna teoría de responsabilidad. Ello incluye, entre otras, cualquier pérdida de
          beneficios, ya sea directa o indirecta, cualquier pérdida de prestigio o reputación, cualquier pérdida de
          datos por su parte, gastos del abastecimiento de bienes o servicios sustitutivos u otras pérdidas intangibles.
        </li>
        <li>
          Los cambios que DOX pueda incorporar en los servicios o la interrupción temporal o definitiva de estos o de
          alguna de sus funciones;
        </li>
        <li>
          La eliminación o daño del contenido y de otros datos de divulgación que se alojan en los servicios o se
          ofrecen a través de estos, así como la imposibilidad de almacenarlos;
        </li>
        <li>
          La negligencia por no haber preservado su contraseña o la información de su cuenta de forma segura y
          confidencial o de haber registrado erróneamente el número de teléfono móvil al que desea se le envíen las
          alertas de DOX.
        </li>
        <li>
          Asimismo, las partes reconocen y dejan constancia que la plataforma computacional proporcionada por DOX no se
          encuentra libre de fallas y, por tanto, DOX no garantiza la disponibilidad y continuidad del funcionamiento de
          El Sitio. Además, pueden verificarse circunstancias ajenas a la voluntad de DOX, que impliquen que El Sitio o
          la plataforma computacional no se encuentren operativos durante un determinado periodo de tiempo. En tales
          casos, DOX procurará restablecer El Sitio y el sistema computacional con la mayor celeridad posible, sin que
          por ello pueda imputársele algún tipo de responsabilidad. cualquier intermitencia o falla al sistema será
          notificado al usuario.
        </li>
        <li>
          Virus u otros elementos en los documentos electrónicos almacenados en los sistemas informáticos de los
          Usuarios. DOX no responderá de los perjuicios ocasionados al Cliente, provenientes del uso inadecuado de las
          tecnologías puestas a disposición de éste, cualquiera sea la forma en la cual se utilicen inadecuadamente
          estas tecnologías. DOX no responderá de los daños producidos a El Sitio por el uso indebido y de mala fe de
          los Usuarios.
        </li>
      </ul>

      <p>
        En Login, registro y comunicación con pasarelas de pago, DOX usa certificados digitales de seguridad (SSL), con
        el fin de encriptar comunicación. DOX no manipula ni almacena datos financieros de sus clientes.
      </p>

      <p>
        En todo caso, la responsabilidad de DOX, contractual, extracontractual o legal, con los Importadores o
        visitantes de El Sitio no excederá del precio efectivamente pagado por el Importador por el Certificado de
        Homologación Electrónico.
      </p>


      <h4>OCTAVO: SEGURIDAD</h4>
      <p>
        Usted es responsable de proteger su cuenta. Le recomendamos que use contraseñas que utilicen la combinación de
        letras mayúsculas y minúsculas, números y símbolos en su cuenta. DOX no puede y no será responsable de cualquier
        pérdida o daño derivados del incumplimiento de los requisitos anteriores.
      </p>
      <p>
        Además, será responsable por la información que registre en el Sistema. Por lo anterior, los Usuarios son los
        únicos responsables ante DOX y terceros de las consecuencias que puedan derivar de la utilización con fines o
        efectos ilícitos o contrarios al presente Términos y Condiciones de aquellos datos que no sean verídicos o
        fidedignos.
      </p>

      <p>
        DOX hace todo lo posible para que la plataforma sea un sitio seguro, , no obstante, adoptamos todas las medidas
        técnicas razonables para conseguirlo. Necesitamos su ayuda para lograr un mejor nivel, para lo cual acepta
        notificar de inmediato a DOX cualquier uso no autorizado de su cuenta de que tenga conocimiento o cualquier
        vulneración a la seguridad que detecte a través del formulario de contacto disponible en <a
        href="www.dox.cl">www.dox.cl</a>.
      </p>

      <h4>NOVENO: PROTECCIÓN DE DATOS PERSONALES</h4>
      <p>
        Los Usuarios garantizan que la información que suministran para el registro en el Sistema de Certificados de
        Homologación Electrónicos desarrollado por DOX es veraz, completa, exacta, actualizada y probable. En
        concordancia con la Ley 19.628, se establece lo siguiente: Los datos que suministren en El Sitio formarán parte
        de la base de datos de DOX y serán destinados para los fines del contrato; responder sus consultas, contacto,
        etc.
      </p>
      <p>
        DOX jamás solicita datos personales o financieros a través de e-mail.
      </p>
      <p>
        DOX presume que los datos han sido incorporados por su titular o por persona autorizada por éste, así como que
        son correctos y exactos.
      </p>
      <p>
        Sin perjuicio de lo anterior, DOX garantiza a los usuarios el libre ejercicio de sus derechos de información,
        modificación, cancelación y bloqueo de sus datos personales establecidos en la Ley 19.628. Por consiguiente, los
        compradores podrán realizar requerimientos que digan relación con dichos derechos, y en un plazo máximo de dos
        días corridos, DOX deberá dar respuesta e implementar efectivamente esta solicitud.
      </p>
      <p>
        Respecto al tratamiento de datos que se realiza para los servicios sobre personas jurídicas, la información
        almacenada es la mínima necesaria para poder hacer la entrega del certificado y realizar los cobros pertinentes.
        No se almacenan los datos personales de quien utiliza el servicio.
      </p>

      <h4>DÉCIMO: ALCANCE DE LAS CONDICIONES INFORMADAS EN EL SITIO</h4>
      <p>
        Todos los contenidos incluidos en este sitio, como textos, material gráfico, logotipos, íconos de botones,
        códigos fuente, imágenes, audio clips, descargas digitales y compilaciones de datos, son propiedad de DOX o de
        sus proveedores de contenidos, y están protegidos por las leyes chilenas e internacionales sobre propiedad
        intelectual. Los materiales gráficos, logotipos, encabezados de páginas, frases publicitarias, iconos de
        botones, textos escritos y nombres de servicios incluidos en este sitio son marcas comerciales, creaciones o
        imágenes comerciales de propiedad de DOX en Chile y en otros países. Dichas marcas, creaciones e imágenes
        comerciales no se pueden usar en relación a ningún producto o servicio que pueda causar confusión entre los
        clientes y en ninguna forma que desprestigie o desacredite a DOX. Las demás marcas comerciales que no sean de
        propiedad de DOX y que aparezcan en este sitio pertenecen a sus respectivos dueños.
      </p>

      <p>
        Todos los derechos no expresamente otorgados en estos Términos y Condiciones son reservados por DOX o sus
        cesionarios, proveedores, editores, titulares de derechos u otros proveedores de contenidos. Ningún producto,
        imagen o sonido pueden ser reproducidos, duplicados, copiados, vendidos, revendidos, visitados o explotados para
        ningún fin, en todo o en parte, sin el consentimiento escrito previo de DOX. No se puede enmarcar o utilizar
        técnicas de enmarcación para encerrar alguna marca comercial, logotipo u otra información registrada o patentada
        (incluyendo imágenes, texto, disposición de páginas, o formulario) de DOX, sin nuestro consentimiento escrito
        previo. Tampoco se puede usar meta etiquetas ni ningún otro “texto oculto” que use el nombre o marcas
        comerciales de DOX, sin autorización escrita previa de esta empresa. Se prohíbe hacer un uso indebido de este
        sitio o de estas marcas, licencias o patentes. Lo anterior, sin perjuicio de las excepciones expresamente
        señaladas en la ley.
      </p>

      <h4>DUODÉCIMO: LEGISLACIÓN APLICABLE Y COMPETENCIA</h4>
      <p>
        Los presentes términos y condiciones se rigen por las leyes de la República de Chile. Cualquier controversia o
        conflicto derivado de la utilización del sitio web de DOX, sus Términos y Condiciones y las Políticas de
        Privacidad, su validez, interpretación, alcance o cumplimiento, será sometida a las leyes aplicables de la
        República de Chile. Ya sea en forma de reclamación o litigio tendrá lugar únicamente en Santiago de Chile, y el
        usuario acepta dicha legislación, jurisdicción y lugar de los tribunales, renunciando con ello a cualquier
        objeción en cuanto a inconveniencia de foro.
      </p>

      <h4>DÉCIMO TERCERO: MODIFICACIONES</h4>
      <p>
        DOX podrá proponer modificaciones a estos Términos y Condiciones, para cuyo efecto enviará un aviso mediante
        correo electrónico a sus clientes y usuarios con al menos 15 días de anticipación a que los cambios comiencen a
        regir.
      </p>
      <p>
        Se entenderá que el Importador ha aceptado íntegramente las modificaciones si dentro de los 15 días siguientes a
        la recepción de la comunicación no manifiesta sus objeciones por escrito.
      </p>
      <p>
        En caso de que el Importador rechace total o parcialmente las modificaciones, DOX podrá poner término al
        contrato.
      </p>
    </div>
  );
};

TermAndConditionsContent.propTypes = {
  onCloseAction: PropTypes.func
};

export default TermAndConditionsContent;
